import { createContext } from 'react'

// AI-CONTEXT: See docs/features/livereport-per-deelnemer.md

/**
 * De deelnemer van een rapportage (`LiveReports2.PersonaID`), voor de widgets
 * eronder. Gezet op dezelfde vier plekken als ReportPeriodContext: de editor
 * (LivereportTemplateBuilder), de viewer in de app (LivereportTemplateViewer),
 * het printvel (LiveReportPrint) en de openbare link (LiveReportOpen2, waar het
 * veld van getPublicLiveReport2 komt).
 *
 * De ruwe waarde van het rapport: `undefined`, `null` of `''` betekent 'geen
 * deelnemer'. Widgets lezen hem nooit rechtstreeks maar via
 * `useWidgetPersona()`, die dat gelijktrekt en hem in sjabloonmodus negeert.
 * Default null = geen deelnemer, dus geen filter.
 *
 * @type {React.Context<string|null|undefined>}
 */
const ReportPersonaContext = createContext(/** @type {string|null|undefined} */ (null))

export default ReportPersonaContext
